export default {
    DEPOSIT: 'deposit',
    WITHDRAW: 'withdraw',
}